<mat-card class="merge-section">
  <mat-card-header>
    <mat-icon mat-card-avatar [color]="iconColor()">{{ icon() }}</mat-icon>
    <mat-card-title>{{ title() }}</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div class="items-list">
      <!-- Items to Remove (red background) -->
      @for (item of itemsToRemoveList(); track item.id) {
        <div class="item-row remove-row">
          <mat-checkbox
            [checked]="isMarkedForRemoval(item.id)"
            (change)="onExistingItemToggle(item.id, !$event.checked)"
            color="warn">
          </mat-checkbox>
          <div class="item-content">
            <span class="item-primary">{{ item.primary }}</span>
            @if (item.secondary) {
              <span class="item-secondary">{{ item.secondary }}</span>
            }
          </div>
          <mat-chip class="status-chip remove">REMOVE</mat-chip>
        </div>
      }

      <!-- Existing items (in both) -->
      @for (item of existingMatchItems(); track item.id) {
        <div class="item-row existing-row">
          <mat-checkbox
            [checked]="true"
            [disabled]="true"
            color="primary">
          </mat-checkbox>
          <div class="item-content">
            <span class="item-primary">{{ item.primary }}</span>
            @if (item.secondary) {
              <span class="item-secondary">{{ item.secondary }}</span>
            }
          </div>
          <mat-chip class="status-chip exists">EXISTS</mat-chip>
        </div>
      }

      <!-- Items to Add (blue background) -->
      @for (item of newReferralItems(); track item.id) {
        <div class="item-row add-row">
          <mat-checkbox
            [checked]="isMarkedForAddition(item.id)"
            (change)="onReferralItemToggle(item.id, $event.checked)"
            color="primary">
          </mat-checkbox>
          <div class="item-content">
            <span class="item-primary">{{ item.primary }}</span>
            @if (item.secondary) {
              <span class="item-secondary">{{ item.secondary }}</span>
            }
          </div>
          <mat-chip class="status-chip add">ADD</mat-chip>
        </div>
      }

      <!-- Empty state if no items at all -->
      @if (itemsToRemoveList().length === 0 && existingMatchItems().length === 0 && newReferralItems().length === 0) {
        <div class="empty-state">No {{ itemLabel() }} to merge</div>
      }
    </div>
  </mat-card-content>
</mat-card>
